export enum AccountingViewMode {
  SPENDS = 'spends',
  CATEGORIES = 'categories',
}
